// @core/api/endpoints/workflow/create_credential.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateCredentialRequest,
  CredentialResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create credential
 * Creates a reusable credential for workflow nodes. Auto-provisions a secret path in SecretService with empty keys based on the credential type schema.
 */
export async function CreateCredential(
  data: CreateCredentialRequest,
  options?: RequestOptions
): Promise<CredentialResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/credentials`;
  const requestOptions = options;
  return client.post<CredentialResponse>(requestPath, data, requestOptions);
}
